export default __webpack_public_path__ + "static/biophilia-logo-5a7bec764bc47e4513f09a5042db90cf.png";